import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './appOrder.component.html',
    styleUrls: ['./appOrder.component.css'],
})

export class AppOrderComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit() {
  }
}
